import { CreateFormStrategy } from '../create-form.interface';

export class CreateTeamStrategy implements CreateFormStrategy {
  readonly header = 'create-form.team.create-team';
  readonly namePlaceholder = 'create-form.team.team-name-placeholder';
  readonly createButtonLabel = 'create-form.team.buttons.create-team';
  readonly cancelButtonLabel = 'create-form.team.buttons.cancel';
}
